import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export function usePageMeta(metaConfig) {
    const { t, i18n } = useTranslation('translation'); // Specify the namespace explicitly as 'translation'

    useEffect(() => {
        const updateMetaTags = () => {
            // Debug logs to check translation status
            // console.log("i18n initialized:", i18n.isInitialized);
            // console.log("Namespace loaded:", i18n.hasLoadedNamespace('translation'));
            // console.log("Current language:", i18n.language);
            // console.log("Translating title:", metaConfig.title, "Result:", t(metaConfig.title));

            // Only update meta tags if i18n is initialized and namespace is loaded
            if (i18n.isInitialized && i18n.hasLoadedNamespace('translation')) {
                // Update document title if provided
                if (metaConfig.title) {
                    const translatedTitle = t(metaConfig.title);
                    document.title = translatedTitle !== metaConfig.title ? translatedTitle : 'Key Choice Lending';
                }
                // Update meta description if provided
                if (metaConfig.description) {
                    const translatedDesc = t(metaConfig.description);
                    let metaDescription = document.querySelector('meta[name="description"]');
                    if (!metaDescription) {
                        metaDescription = document.createElement('meta');
                        metaDescription.name = 'description';
                        document.head.appendChild(metaDescription);
                    }
                    metaDescription.content = translatedDesc !== metaConfig.description ? translatedDesc : 'Description';
                }

                // Update Open Graph tags if provided
                if (metaConfig.og) {
                    const translatableOgTags = ['title', 'description'];
                    const staticOgTags = ['image', 'type', 'url'];

                    // Handle translatable OG tags
                    translatableOgTags.forEach(tag => {
                        if (metaConfig.og[tag]) {
                            const translatedValue = t(metaConfig.og[tag]);
                            let ogTag = document.querySelector(`meta[property="og:${tag}"]`);
                            if (!ogTag) {
                                ogTag = document.createElement('meta');
                                ogTag.setAttribute('property', `og:${tag}`);
                                document.head.appendChild(ogTag);
                            }
                            ogTag.content = translatedValue !== metaConfig.og[tag] ? translatedValue : `Fallback OG ${tag}`;
                        }
                    });

                    // Handle static OG tags (no translation)
                    staticOgTags.forEach(tag => {
                        if (metaConfig.og[tag]) {
                            let ogTag = document.querySelector(`meta[property="og:${tag}"]`);
                            if (!ogTag) {
                                ogTag = document.createElement('meta');
                                ogTag.setAttribute('property', `og:${tag}`);
                                document.head.appendChild(ogTag);
                            }
                            ogTag.content = metaConfig.og[tag];
                        }
                    });
                }
            } else {
                console.warn("Translations not ready, skipping meta tag updates.");
            }
        };

        // Run on initial load
        updateMetaTags();

        // Run whenever language changes or namespace is loaded
        i18n.on('languageChanged', updateMetaTags);
        i18n.on('loaded', updateMetaTags);

        // Cleanup function
        return () => {
            i18n.off('languageChanged', updateMetaTags);
            i18n.off('loaded', updateMetaTags);
        };
    }, [t, i18n, metaConfig]);
}
